module.exports = __webpack_public_path__ + "static/img/cover_4.9593cb39.png";